import {gsap} from 'gsap';

export default class VideoIframeModal {
  constructor(videoModal) {
    this.root = videoModal;
    this.body = document.querySelector('body');
    this.openButton = this.root.querySelector('.js-open-video-modal');
    this.iframeContainer = this.root.querySelector('.js-iframe-container');
    this.closeButton = this.root.querySelector('.js-close-iframe-modal');
    this.ifraemWrapper = this.root.querySelector('.js-iframe-wrapper');
    this.ytVideoId = this.iframeContainer.dataset.ytId;

    this.init();
  }

  init() {
    this.iframeContainer.addEventListener('click', () => this.closeVideoModal());
    this.closeButton.addEventListener('click', () => this.closeVideoModal());
    this.openButton.addEventListener('click', () => this.openVideoModal());
  }

  openVideoModal() {
    this.body.classList.add('--overflow-hidden');
    this.iframeContainer.classList.add('--active');

    if (this.ytVideoId) {
      this.openYtVideo();
    }
  }

  closeVideoModal() {
    this.body.classList.remove('--overflow-hidden');
    this.iframeContainer.classList.remove('--active');
    this.ifraemWrapper.innerHTML = '';
  }

  openYtVideo() {
    this.ifraemWrapper.innerHTML = `
      <iframe width="560" height="315" src="https://www.youtube.com/embed/${this.ytVideoId}?rel=0&autoplay=1" frameborder="0" allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    `;
  }

}
